/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useEffect,
  useState,
  useRef,
  type ReactElement,
  useContext
} from 'react'
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  Link,
  ListItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  UnorderedList
} from '@chakra-ui/react'
import { connection, RoomCode } from '../../renderer/roomConnector'
import { RoomSettingsContext } from '../+RoomSettingsContext'
import { ErrorModal, ScreenSizeErrorModal } from '../../components/Modals'
import SideNav from '../../components/SideNav'
import StickyNotes from '../../components/StickyNote'
import '@fontsource/kalam'
import '@fontsource-variable/caveat'
import { activities, universalRoomOptions } from '../../activities'
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck'
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'

declare global {
  interface Window {
    featuredEmojiIndex: number | null
    phase: string
  }
}

// window.featuredEmojiIndex = null

interface playerData {
  id: string
  name: string
  emoji: string | null
  guess: string | null
}

interface emojiData {
  emoji: string
  players: string[]
  archived: boolean
}

const firstNames = [
  'Alice',
  'Bob',
  'Charlie',
  'David',
  'Ella',
  'Frank',
  'Grace',
  'Hannah',
  'Isaac',
  'Jack',
  'Katherine',
  'Liam',
  'Mia',
  'Nathan',
  'Olivia',
  'Peter',
  'Quincy',
  'Rachel',
  'Samuel',
  'Tiffany',
  'Ursula',
  'Victoria',
  'William',
  'Xavier',
  'Yvonne',
  'Zachary'
]

const yellowFaceEmojis = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '😂',
  '🤣',
  '😊',
  '😇',
  '🙂',
  '🙃',
  '😉',
  '😌',
  '😍',
  '😘',
  '😗',
  '😙',
  '😚',
  '😋',
  '😜',
  '😝',
  '😛',
  '🤗',
  '🤔',
  '😏',
  '😎',
  '🤓',
  '🤑'
]

const randomEmoji = (): string => {
  // Check if there are emojis left in the array
  if (yellowFaceEmojis.length === 0) {
    return 'No more emojis available!'
  }

  // Get a random index
  const randomIndex = Math.floor(Math.random() * yellowFaceEmojis.length)

  // Get the emoji at the random index
  const randomEmoji = yellowFaceEmojis[randomIndex]

  // Remove the emoji from the array to avoid repetition
  yellowFaceEmojis.splice(randomIndex, 1)

  // Return the random emoji
  return randomEmoji
}

const colors = ['#286668', '#3EBC87', '#EACE3A', '#F9AB38', '#ED574F']

const tempEntries = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25
]
  .slice(0, 4)
  .map((value: number, index: number) => {
    const name = firstNames[Math.floor(Math.random() * firstNames.length)]
    return {
      id: 'abc1' + value.toString(),
      name,
      emoji: null,
      guess: index % 2 === 0 ? name : null
    }
  })

const initialRoomSettings = {
  activity: activities.emojiMirror,
  options: {
    ...universalRoomOptions,
    roundTime: {
      label: 'How many seconds to guess your partner',
      type: 'number',
      value: 50,
      min: 50,
      max: 600
    }
  }
}

const MIN_PLAYERS = 2

let CHANNEL_GLOBAL: any = null

let orbitInteral: any
let timerInteral: any

// interface StickyNoteData {
//   text: string
//   color: string
//   style?: any
//   onClick?: any
// }

const shuffle = (array: any[]): any[] => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

interface PlayerNameData {
  name: string
  nameFontSize: number
  rotation: number
  colorIndex: number
  sx: any
}

const PlayerName: React.FC<PlayerNameData> = ({
  colorIndex,
  nameFontSize,
  rotation,
  name,
  sx
}) => {
  return (
    <Box
      // key={item === null ? `placeholder-${index}` : item.id}
      // outline={`1px ${(item === null ? 'dashed' : 'solid')} currentcolor`}
      color={'currentcolor'}
      style={{
        transform: `rotate(${rotation}deg)`,
        ...sx
      }}
      transition="all 200ms linear"
    >
      <Flex
        style={{
          transform: `rotate(${0 - rotation}deg)`
        }}
        transition="all 200ms linear"
        justifyContent="center"
        alignItems="center"
      >
        <Text
          fontSize={`${nameFontSize}vw`}
          textAlign="center"
          fontWeight={800}
          letterSpacing="-0.1em"
          position="relative"
          sx={{
            '&:before': {
              WebkitTextStrokeWidth: '0.03em',
              WebkitTextStrokeColor: colors[colorIndex % colors.length],
              content: `"${name}"`,
              position: 'absolute',
              top: '0',
              left: '0',
              zIndex: '-1'
            },
            '&:after': {
              content: `"${name}"`,
              position: 'absolute',
              top: '0.125em',
              left: '0',
              zIndex: '-1',
              textShadow: 'none',
              backgroundImage: `
                          linear-gradient(
                            45deg,
                            transparent 45%,
                            ${colors[colorIndex % colors.length]}aa 45%,
                            ${colors[colorIndex % colors.length]}aa 55%,
                            transparent 0
                            )`,
              backgroundSize: '.025em .025em',
              backgroundClip: 'text',
              textFillColor: 'transparent',

              animation: 'shad-anim 15s linear infinite'
            }
          }}
        >
          {name}
        </Text>
      </Flex>
    </Box>
  )
}

const Page: React.FC = () => {
  const [roomCode, setRoomCode] = useState<string>('')
  const { roomSettings, setRoomSettings } = useContext(RoomSettingsContext)
  const [preventRefresh, setPreventRefresh] = useState<boolean>(false)
  const [triggerRefresh, setTriggerRefresh] = useState<boolean>(false)
  const [isConnecting, setIsConnecting] = useState<boolean>(false)

  const [featuredEmojiIndex, setFeaturedEmojiIndex] = useState<number | null>(
    null
  )
  const [players, setPlayers] = useState<playerData[]>(
    import.meta.env.MODE === 'development' ? tempEntries : []
  )
  const [emojis, setEmojis] = useState<emojiData[]>([])
  const [globalRotation, setGlobalRotation] = useState<number>(0)
  const [phase, setPhase] = useState<string>('setup')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [timeLeft, setTimeLeft] = useState<number>(0)

  const refreshList = (): void => {
    CHANNEL_GLOBAL.send({
      action: 'updatePlayerList',
      players
    })
  }

  const updateItems = (
    message: {
      uid: string
      alias: string
      desciption: string
      type: string
      submission?: string
      guess?: string
    },
    channel: any
  ): void => {
    if (message.type === 'join') {
      setPlayers((prevValue: any[]) => {
        const tempplayers = [
          ...prevValue,
          {
            id: message.uid + new Date().toISOString(),
            name: message.alias,
            emoji: '😂',
            guess: null,
            archived: false
          }
        ]
        return tempplayers
      })
    }
    if (
      message.type === 'guess' &&
      ['fadeInTimer', 'timer'].includes(window.phase)
    ) {
      setPlayers((prevVal: any) => {
        const newPreVal: any = [...prevVal]
        newPreVal.find((player: any) => {
          return player.name === message.alias
        }).guess = message.guess
        return newPreVal
      })
    }
  }

  const triggerAction = (message: any, channel: any): void => {
    if (message.action !== 'guess') {
      updateItems(message, channel)
    }
  }

  const triggerEnter = (message: any): void => {
    if (message.self) return
    setPlayers((prevValue: any) => {
      const tempPlayers = [...prevValue]
      if (
        tempPlayers.some((player: any) => {
          return player.name.toLowerCase() === message.alias.toLowerCase()
        })
      ) {
        return tempPlayers
      }
      tempPlayers.push({
        id: message.uid,
        name: message.alias,
        emoji: null,
        guess: null
      })
      return tempPlayers
    })
    // setTriggerRefresh(true)
  }

  const EMCallback = (results: any): void => {
    if (results !== false) {
      setRoomCode(results.roomCode)
      CHANNEL_GLOBAL = results.channel
    } else {
      setErrorMessage('Failed to connect, try refreshing the window')
    }
  }

  const assignEmojis = (): void => {
    const tempEmojis: emojiData[] = []
    let tempPlayers: playerData[] = []
    tempPlayers = shuffle(players)
    tempPlayers = tempPlayers.map((player, index) => {
      const isLast = index + 1 === players.length
      if (index % 2 === 0 && !isLast) {
        const tempEmoji = randomEmoji()
        tempEmojis.push({
          emoji: tempEmoji,
          players: [player.name],
          archived: false
        })
        player.emoji = tempEmoji
      } else {
        tempEmojis[tempEmojis.length - 1].players.push(player.name)
        player.emoji = tempEmojis[tempEmojis.length - 1].emoji
      }
      return player
    })

    setEmojis(tempEmojis)
    setPlayers([...tempPlayers])
  }

  useEffect(() => {
    setRoomSettings(initialRoomSettings)
    if (!isConnecting) {
      setIsConnecting(true)
      connection('em', EMCallback, { triggerAction, triggerEnter })
    }
  }, [])

  useEffect(() => {
    if (CHANNEL_GLOBAL !== null) {
      refreshList()
      setTriggerRefresh(false)
    }
  }, [triggerRefresh])

  useEffect(() => {
    window.phase = phase
    switch (phase) {
      case 'setup':
        clearInterval(orbitInteral)
        orbitInteral = setInterval(() => {
          setGlobalRotation((prevVal) => prevVal + 0.5)
        }, 200)
        break
      case 'fadeOutSetup':
        assignEmojis()
        transitionTo('fadeInTimer', 500)
        break
      case 'fadeInTimer':
        clearInterval(timerInteral)
        clearInterval(orbitInteral)
        refreshList()
        transitionTo('timer', 500)
        break
      case 'timer':
        setTimeLeft(roomSettings.options.roundTime.value)
        timerInteral = setInterval(() => {
          setTimeLeft((prevVal) => {
            return prevVal - 1
          })
        }, 1000)
        break
      case 'fadeOutTimer':
        clearInterval(timerInteral)
        transitionTo('fadeInResults', 500)
        break
      case 'fadeInResults':
        clearInterval(orbitInteral)
        setEmojis((prevValue) => {
          if (window.featuredEmojiIndex !== null) {
            prevValue[window.featuredEmojiIndex].archived = true
          }
          return prevValue
        })
        pickRandomEmoji()
        if (window.featuredEmojiIndex !== null) {
          transitionTo('results', 500)
        } else {
          transitionTo('fadeInEnd', 0)
        }

        break
      case 'results':
        break
      case 'fadeOutResults':
        transitionTo('fadeInResults', 500)
        break
      case 'fadeInEnd':
        transitionTo('end', 500)
        break
      default:
    }
  }, [phase])

  useEffect(() => {
    if (phase === 'timer' && timeLeft <= 0) {
      clearInterval(timerInteral)
      // playsound?
      transitionTo('fadeOutTimer', 2000)
      CHANNEL_GLOBAL.send({
        action: 'showResults'
      })
    }
  }, [timeLeft])

  const pickRandomEmoji = (): void => {
    const filteredIndexes = emojis
      .map((item, index) => {
        if (item.archived) {
          return -1
        }
        return index
      })
      .filter((item) => item >= 0)
    if (filteredIndexes.length > 0) {
      const newIndex = (filteredIndexes.length * Math.random()) | 0
      setFeaturedEmojiIndex(filteredIndexes[newIndex])
      window.featuredEmojiIndex = filteredIndexes[newIndex]
    } else {
      setFeaturedEmojiIndex(null)
      window.featuredEmojiIndex = null
    }
    console.log(window.featuredEmojiIndex)
  }

  const startGame = (): void => {
    setPhase('fadeOutSetup')
  }

  const transitionTo = (phase: string, time: number): void => {
    setTimeout(() => {
      setPhase(phase)
    }, time)
  }

  const nameBubbles: any[] = [...players].slice(0, 16)

  if (nameBubbles.length > 12 && nameBubbles.length % 2 === 1) {
    nameBubbles.push(null)
  }

  const bubbleSize =
    nameBubbles.length > 5
      ? nameBubbles.length > 12
        ? 10 - nameBubbles.length * 0.2
        : 10 - nameBubbles.length * 0.2
      : 10

  const NextButton = (props: any): ReactElement => {
    return (
      <Box
        as="button"
        mb="0.5vh"
        borderRadius="10vw"
        pos="absolute"
        color="#ED574F"
        letterSpacing="-0.005em"
        fontWeight={800}
        fontSize="min(64px, 5vh)"
        onClick={() => {
          setPhase('fadeOutResults')
        }}
        transform="rotate(-5deg)"
        transition="opacity 5000ms ease"
        opacity={props.opacity}
        left="20px"
        bottom="2vh"
        sx={{
          '&:before': {
            WebkitTextStrokeWidth: '0.03em',
            WebkitTextStrokeColor: '000000aa',
            content: '"Next"',
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '-1'
          },
          '&:after': {
            content: '"Next"',
            position: 'absolute',
            top: '0.125em',
            left: '0',
            zIndex: '-1',
            textShadow: 'none',
            transition: 'top 250ms ease',
            backgroundImage: `
                    linear-gradient(
                      45deg,
                      transparent 45%,
                      #000000aa 45%,
                      #000000aa 55%,
                      transparent 0
                      )`,
            backgroundSize: '.05em .05em',
            backgroundClip: 'text',
            textFillColor: 'transparent',

            animation: 'shad-anim 15s linear infinite'
          },
          _hover: {
            '&:after': {
              top: '0.2em'
            }
          }
        }}
      >
        Next
      </Box>
    )
  }

  const PlayAgain = (): ReactElement => {
    return (
      <Box
        as="button"
        mb="5.5vh"
        borderRadius="10vw"
        pos="absolute"
        color="#ED574F"
        letterSpacing="-0.005em"
        fontWeight={800}
        fontSize="5vw"
        onClick={() => {
          window.location.reload()
        }}
        transform="rotate(-5deg)"
        sx={{
          '&:before': {
            WebkitTextStrokeWidth: '0.03em',
            WebkitTextStrokeColor: '000000aa',
            content: '"Play Again?"',
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '-1'
          },
          '&:after': {
            content: '"Play Again?"',
            position: 'absolute',
            top: '0.125em',
            left: '0',
            zIndex: '-1',
            textShadow: 'none',
            transition: 'top 250ms ease',
            backgroundImage: `
              linear-gradient(
                45deg,
                transparent 45%,
                #000000aa 45%,
                #000000aa 55%,
                transparent 0
                )`,
            backgroundSize: '.05em .05em',
            backgroundClip: 'text',
            textFillColor: 'transparent',

            animation: 'shad-anim 15s linear infinite'
          },
          _hover: {
            '&:after': {
              top: '0.2em'
            }
          }
        }}
      >
        Play Again?
      </Box>
    )
  }

  const Timer = (props: { timeLeft: number }): ReactElement => {
    const { timeLeft } = props
    return (
      <Box
        // mb="5.5vh"
        borderRadius="10vw"
        // pos="absolute"
        color="#ED574F"
        letterSpacing="-0.005em"
        fontWeight={800}
        fontSize="5vw"
        transform="rotate(-5deg)"
        sx={{
          '&:before': {
            WebkitTextStrokeWidth: '0.03em',
            WebkitTextStrokeColor: '000000aa',
            content: `"${timeLeft}"`,
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '-1'
          },
          '&:after': {
            content: `"${timeLeft}"`,
            position: 'absolute',
            top: '0.125em',
            left: '0',
            zIndex: '-1',
            textShadow: 'none',
            transition: 'top 250ms ease',
            backgroundImage: `
              linear-gradient(
                45deg,
                transparent 45%,
                #000000aa 45%,
                #000000aa 55%,
                transparent 0
                )`,
            backgroundSize: '.05em .05em',
            backgroundClip: 'text',
            textFillColor: 'transparent',

            animation: 'shad-anim 15s linear infinite'
          }
        }}
      >
        {timeLeft}
      </Box>
    )
  }

  return (
    <Box sx={styles.container}>
      {/* Startup Screen */}
      <Flex
        pos="absolute"
        left="0"
        top="0"
        right="0"
        bottom="0"
        justifyContent="center"
        alignItems="center"
        transition="all 500ms ease"
        opacity={phase === 'setup' ? 1 : 0}
        display={['setup', 'fadeOutSetup'].includes(phase) ? 'flex' : 'none'}
      >
        {nameBubbles.map(
          (item: playerData | null, index: number): ReactElement => {
            const rotation = (360 / nameBubbles.length) * index + globalRotation
            const transformOrigin =
              nameBubbles.length > 12 ? (index % 2 === 0 ? 41 : 30) : 41
            const top =
              nameBubbles.length > 12 ? (index % 2 === 0 ? 0 : 5.5) : 0
            const fontSize = nameBubbles.length > 12 ? 2.8 : 3.5

            return (
              <Box
                w={`${bubbleSize}vw`}
                h={`${bubbleSize}vw`}
                left={`calc(50% - ${bubbleSize / 2}vw)`}
                top={`calc(${top}vw + 30px)`}
                key={item === null ? `placeholder-${index}` : item.id}
                position="absolute"
                // outline={`1px ${(item === null ? 'dashed' : 'solid')} currentcolor`}
                color={'currentcolor'}
                style={{
                  transform: `rotate(${rotation}deg)`
                }}
                transition="all 200ms linear"
                transformOrigin={`50% calc(${transformOrigin}vh - 0vw)`}
                borderRadius={`${bubbleSize}vw`}
              >
                {item !== null && (
                  <Flex
                    w={`${bubbleSize}vw`}
                    h={`${bubbleSize}vw`}
                    borderRadius={`${bubbleSize}vw`}
                    style={{
                      transform: `rotate(${0 - rotation}deg)`
                    }}
                    transition="all 200ms linear"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      fontSize={`${fontSize}vw`}
                      textAlign="center"
                      fontWeight={800}
                      letterSpacing="-0.1em"
                      position="relative"
                      sx={{
                        '&:before': {
                          WebkitTextStrokeWidth: '0.03em',
                          WebkitTextStrokeColor: colors[index % colors.length],
                          content: `"${item.name}"`,
                          position: 'absolute',
                          top: '0',
                          left: '0',
                          zIndex: '-1'
                        },
                        '&:after': {
                          content: `"${item.name}"`,
                          position: 'absolute',
                          top: '0.125em',
                          left: '0',
                          zIndex: '-1',
                          textShadow: 'none',
                          backgroundImage: `
                          linear-gradient(
                            45deg,
                            transparent 45%,
                            ${colors[index % colors.length]}aa 45%,
                            ${colors[index % colors.length]}aa 55%,
                            transparent 0
                            )`,
                          backgroundSize: '.025em .025em',
                          backgroundClip: 'text',
                          textFillColor: 'transparent',

                          animation: 'shad-anim 15s linear infinite'
                        }
                      }}
                    >
                      {item.name}
                    </Text>
                  </Flex>
                )}
              </Box>
            )
          }
        )}
        {players.length >= MIN_PLAYERS && (
          <Box
            as="button"
            mb="5.5vh"
            borderRadius="10vw"
            pos="absolute"
            color="#ED574F"
            letterSpacing="-0.005em"
            fontWeight={800}
            fontSize="5vw"
            onClick={startGame}
            transform="rotate(-5deg)"
            sx={{
              '&:before': {
                WebkitTextStrokeWidth: '0.03em',
                WebkitTextStrokeColor: '000000aa',
                content: '"Start"',
                position: 'absolute',
                top: '0',
                left: '0',
                zIndex: '-1'
              },
              '&:after': {
                content: '"Start"',
                position: 'absolute',
                top: '0.125em',
                left: '0',
                zIndex: '-1',
                textShadow: 'none',
                transition: 'top 250ms ease',
                backgroundImage: `
                linear-gradient(
                  45deg,
                  transparent 45%,
                  #000000aa 45%,
                  #000000aa 55%,
                  transparent 0
                  )`,
                backgroundSize: '.05em .05em',
                backgroundClip: 'text',
                textFillColor: 'transparent',

                animation: 'shad-anim 15s linear infinite'
              },
              _hover: {
                '&:after': {
                  top: '0.2em'
                }
              }
            }}
          >
            Start
          </Box>
        )}
        {players.length < MIN_PLAYERS && (
          <Box
            mb="5.5vh"
            borderRadius="10vw"
            pos="absolute"
            color="#ED574F"
            letterSpacing="-0.005em"
            lineHeight="1em"
            fontWeight={800}
            fontSize="3.5vw"
            transform="rotate(-5deg)"
            textAlign="center"
            sx={{
              '&:before': {
                WebkitTextStrokeWidth: '0.03em',
                WebkitTextStrokeColor: '000000aa',
                content: `"${MIN_PLAYERS}+ Players\\ARequired"`,
                whiteSpace: 'pre',
                textAlign: 'center',
                lineHeight: '1em',
                position: 'absolute',
                top: '0',
                left: '0',
                zIndex: '-1'
              },
              '&:after': {
                content: `"${MIN_PLAYERS}+ Players\\ARequired"`,
                whiteSpace: 'pre',
                lineHeight: '1em',
                position: 'absolute',
                textAlign: 'center',
                top: '0.125em',
                left: '0',
                zIndex: '-1',
                textShadow: 'none',
                transition: 'top 250ms ease',
                backgroundImage: `
                linear-gradient(
                  45deg,
                  transparent 45%,
                  #000000aa 45%,
                  #000000aa 55%,
                  transparent 0
                  )`,
                backgroundSize: '.05em .05em',
                backgroundClip: 'text',
                textFillColor: 'transparent',

                animation: 'shad-anim 15s linear infinite'
              },
              _hover: {
                '&:after': {
                  top: '0.2em'
                }
              }
            }}
          >
            {MIN_PLAYERS}+ Players
            <br />
            Required
          </Box>
        )}
      </Flex>
      {/* end Startup screen */}
      {/* Timer Screen */}
      <Flex
        pos="absolute"
        left="0"
        top="0"
        right="0"
        bottom="0"
        justifyContent="center"
        alignItems="center"
        transition="all 500ms ease"
        opacity={phase === 'timer' ? 1 : 0}
        display={
          ['fadeInTimer', 'timer', 'fadeOutTimer'].includes(phase)
            ? 'flex'
            : 'none'
        }
        flexDir="column"
      >
        <Heading mb="0">
          Look at the emoji on your device and find your mirror!
        </Heading>
        <Timer timeLeft={timeLeft} />
      </Flex>
      {/* Timer Screen End  */}

      {/* Guessing screen */}
      <Flex
        pos="absolute"
        left="0"
        top="0"
        right="0"
        bottom="0"
        justifyContent="center"
        alignItems="flex-start"
        transition="all 500ms ease"
        opacity={['results', 'fadeInResults'].includes(phase) ? 1 : 0}
        display={
          ['fadeOutResults', 'fadeInResults', 'results'].includes(phase)
            ? 'flex'
            : 'none'
        }
      >
        {featuredEmojiIndex !== null && (
          <Box>
            <Text
              fontSize="10vw"
              fontWeight={800}
              letterSpacing="-0.9vw"
              lineHeight="1em"
              position="relative"
              mb="0.25em"
            >
              {emojis[featuredEmojiIndex].emoji}
            </Text>
            <Grid
              templateColumns={`repeat(${emojis[featuredEmojiIndex].players.length}, 1fr)`}
              w="90vw"
            >
              {emojis[featuredEmojiIndex].players.map(
                (player: string, index: number) => {
                  const playerGuess =
                    players.find((allPlayer) => {
                      return allPlayer.name === player
                    })?.guess ?? 'none'

                  const success =
                    emojis[featuredEmojiIndex].players.includes(playerGuess)

                  return (
                    <Flex
                      key={`player-${index}`}
                      flexDir="row"
                      justifyContent="center"
                    >
                      <Box pos="relative" maxW="25vw" w="100%" display="block">
                        <StickyNotes color={success ? 'green' : 'red'}>
                          <Box textAlign="center">
                            <PlayerName
                              name={player}
                              colorIndex={index}
                              rotation={0}
                              nameFontSize={4.5}
                              sx={{
                                display: 'inline-block'
                              }}
                            />
                            <br />
                            <Icon
                              ml="1em"
                              boxSize="6em"
                              position="relative"
                              top="0.5em"
                              sx={
                                {
                                  // color: success ? 'green.500' : 'red.500'
                                }
                              }
                              as={success ? AiOutlineCheck : AiOutlineClose}
                            />
                          </Box>
                        </StickyNotes>
                      </Box>
                    </Flex>
                  )
                }
              )}
            </Grid>
            <NextButton opacity={phase === 'results' ? 1 : 0} />
          </Box>
        )}
      </Flex>
      {/* end Guessing Screen */}

      {/* End Screen */}
      <Flex
        pos="absolute"
        left="0"
        top="0"
        right="0"
        bottom="0"
        justifyContent="center"
        alignItems="center"
        transition="all 500ms ease"
        opacity={phase === 'end' ? 1 : 0}
        display={['end', 'fadeInEnd'].includes(phase) ? 'flex' : 'none'}
      >
        <PlayAgain />
      </Flex>
      {/* End Screen End  */}
      <ErrorModal
        isOpen={errorMessage !== null}
        onClose={() => {
          setErrorMessage(null)
        }}
      >
        {errorMessage}
      </ErrorModal>
      <ScreenSizeErrorModal />

      {['setup', 'fadeOutSetup'].includes(phase) && (
        <>
          <RoomCode roomCode={roomCode} />
        </>
      )}
      <SideNav />
      <style>
        {`
        @keyframes wiggleText {
            0%, 66.001% {
              font-weight: 400;
              transform: rotate(2deg);
            }

            0.001%,33% {
              font-weight: 500;
              transform: rotate(-3deg);
            }

            33.001%,66% {
              font-weight: 400;
              transform: rotate(-0deg);
            }
          }
          @keyframes shad-anim {
            0% {background-position: 0 0}
            0% {background-position: 100% -100%}
            }
          `}
      </style>
    </Box>
  )
}

const styles = {
  container: {
    pos: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    p: '20px'
  },
  grid: {
    pos: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
}

export { Page }
